<template>
  <div class="c-live-distribute">
    <plv-dialog
      width="520px"
      show-footer-btn
      :visible="visible"
      :title="type === 'add' ? '添加用量' : '回收用量'"
      :close-on-click-mask="false"
      :closable="false"
      @confirm="handleSubmit"
      @cancel="handleDialogClose"
      @close="handleDialogClose"
    >
      <plv-form
        :model="form"
        label-width="180px"
      >
        <plv-form-item label="当前计费方式" class="c-live-distribute__text">
          <div>{{ assignedForm.chargeTypeDesc }}</div>
        </plv-form-item>
        <plv-form-item v-if="type === 'add'" label="分配后计费方式">
          <plv-select v-model="billingMethod">
            <plv-select-option
              v-for="option of billingMethodOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </plv-select>
        </plv-form-item>
        <plv-form-item v-if="showConcurrent" label="并发数">
          <template v-if="type === 'add' && isResourceLimit" slot="tips">
            <span>{{ $_getConcurrentTip(form.concurrent, assignedForm.concurrent) }}</span>
          </template>
          <template v-else-if="type === 'recycle'" slot="tips">
            <span>{{ $_getResourceRecycleTip(assignedForm.concurrent, unitData['concurrent']) }}</span>
          </template>
          <plv-input-number
            v-model="form.concurrent"
            size="medium"
            :en-length="1"
            placeholder="请输入并发数"
            suffix="2342423"
            :max="type === 'recycle' ? assignedForm.concurrent : 100000000"
          >
            <template slot="suffix">
              <div class="g-input-append">{{ unitData['concurrent'] }}</div>
            </template>
          </plv-input-number>
        </plv-form-item>

        <plv-form-item v-if="showMinutes" label="直播分钟数">
          <template v-if="type === 'add' && isResourceLimit" slot="tips">
            <span>{{ $_getMinutesTip(form.minutes) }}</span>
          </template>
          <template v-else-if="type === 'recycle'" slot="tips">
            <span>{{ $_getResourceRecycleTip(assignedForm.minutes, unitData['minutes']) }}</span>
          </template>
          <plv-input-number
            v-model="form.minutes"
            size="medium"
            placeholder="请输入直播分钟数"
            :en-length="1"
            :max="type === 'recycle' ? assignedForm.minutes : 100000000"
          >
            <template slot="suffix">
              <div class="g-input-append">{{ unitData['minutes'] }}</div>
            </template>
          </plv-input-number>
        </plv-form-item>

        <plv-form-item v-if="showLiveFlow" label="直播流量">
          <template v-if="type === 'add' && isResourceLimit" slot="tips">
            <span>{{ $_getLiveFlowTip(form.liveFlow) }}</span>
          </template>
          <template v-else-if="type === 'recycle'" slot="tips">
            <span>{{ $_getResourceRecycleTip(assignedForm.validLiveFlow, unitData['flow']) }}</span>
          </template>
          <plv-input-number
            v-model="form.liveFlow"
            size="medium"
            placeholder="请输入直播流量"
            :en-length="1"
            :max="type === 'recycle' ? assignedForm.validLiveFlow : 100000000"
          >
            <template slot="suffix">
              <div class="g-input-append">{{ unitData['flow'] }}</div>
            </template>
          </plv-input-number>
        </plv-form-item>

        <plv-form-item label="连麦分钟数">
          <template v-if="type === 'add' && isResourceLimit" slot="tips">
            <span>{{ $_getMicMinutesTip(form.linkMicMinutes) }}</span>
          </template>
          <template v-else-if="type === 'recycle'" slot="tips">
            <span>{{ $_getResourceRecycleTip(assignedForm.linkMicMinutes, unitData['linkMicMinutes']) }}</span>
          </template>
          <plv-input-number
            v-model="form.linkMicMinutes"
            size="medium"
            placeholder="请输入连麦分钟数"
            :en-length="1"
            :max="type === 'recycle' ? assignedForm.linkMicMinutes : 100000000"
          >
            <template slot="suffix">
              <div class="g-input-append">{{ unitData['linkMicMinutes'] }}</div>
            </template>
          </plv-input-number>
        </plv-form-item>

        <plv-form-item label="云导播台分钟数">
          <template v-if="type === 'add' && isResourceLimit" slot="tips">
            <span>{{ $_getGuideMinutesTip(form.guideMinutes) }}</span>
          </template>
          <template v-else-if="type === 'recycle'" slot="tips">
            <span>{{ $_getResourceRecycleTip(assignedForm.guideMinutes, unitData['guideMinutes']) }}</span>
          </template>
          <plv-input-number
            v-model="form.guideMinutes"
            size="medium"
            placeholder="请输入云导播台分钟数"
            :en-length="1"
            :max="type === 'recycle' ? assignedForm.guideMinutes : 100000000"
          >
            <template slot="suffix">
              <div class="g-input-append">{{ unitData['guideMinutes'] }}</div>
            </template>
          </plv-input-number>
        </plv-form-item>

        <plv-form-item label="频道数">
          <template v-if="type === 'add' && isResourceLimit" slot="tips">
            <span>{{ $_getChannelTip(form.maxChannels, assignedForm.maxChannels) }}</span>
          </template>
          <template v-else-if="type === 'recycle'" slot="tips">
            <span>{{ $_getResourceRecycleTip(assignedForm.maxChannels, unitData['maxChannels']) }}</span>
          </template>
          <plv-input-number
            v-model="form.maxChannels"
            size="medium"
            placeholder="请输入频道数"
            :en-length="1"
            :max="type === 'recycle' ? assignedForm.maxChannels : 100000000"
          >
            <template slot="suffix">
              <div class="g-input-append">{{ unitData['maxChannels'] }}</div>
            </template>
          </plv-input-number>
        </plv-form-item>

        <plv-form-item
          v-if="showAiPptVideoWithDigitalHumanDuration"
          label="视频创作（含数字人）"
        >
          <template v-if="isResourceLimit" slot="tips">
            <span>{{ $_getAiPptVideoWithDigitalHumanDurationTips(form.aiPptVideoWithDigitalHumanDuration) }}</span>
          </template>
          <template v-else-if="type === 'recycle'" slot="tips">
            <span>{{ $_getResourceRecycleTip(assignedForm.availableAiPPTVideoDigitalHumanDuration, unitData['aiPptVideoWithDigitalHumanDuration']) }}</span>
          </template>
          <plv-input-number
            v-model="form.aiPptVideoWithDigitalHumanDuration"
            size="medium"
            placeholder="请输入分钟数"
            :en-length="1"
          >
            <template slot="suffix">
              <div class="g-input-append">{{ unitData['aiPptVideoWithDigitalHumanDuration'] }}</div>
            </template>
          </plv-input-number>
        </plv-form-item>

        <plv-form-item
          v-if="showAiPptVideoDuration"
          label="视频创作（不含数字人）"
        >
          <template v-if="isResourceLimit" slot="tips">
            <span>{{ $_getAiPptVideoDurationTips(form.aiPptVideoDuration) }}</span>
          </template>
          <template v-else-if="type === 'recycle'" slot="tips">
            <span>{{ $_getResourceRecycleTip(assignedForm.availableAiPPTVideoDuration, unitData['aiPptVideoDuration']) }}</span>
          </template>
          <plv-input-number
            v-model="form.aiPptVideoDuration"
            size="medium"
            placeholder="请输入分钟数"
            :en-length="1"
          >
            <template slot="suffix">
              <div class="g-input-append">{{ unitData['aiPptVideoDuration'] }}</div>
            </template>
          </plv-input-number>
        </plv-form-item>
      </plv-form>
      <div v-if="!isResourceLimit && type === 'add'" class="c-live-distribute__tip">
        <plv-tips>当前主账号不限制分配资源量，分账号的消耗仍会汇总到主账号结算</plv-tips>
      </div>
    </plv-dialog>
  </div>
</template>

<script>
import dialogMixin from '@/mixins/dialog';
import accountInfoMixin from '@/mixins/accountInfo';
import { chargeTypeEnum } from '@/utils/type';
import { mapState } from 'vuex';
import { ynToBool } from '@polyv/utils/boolean';

const defaultForm = {
  chargeType: '',
  concurrent: 0,
  minutes: 0,
  liveFlow: 0,
  linkMicMinutes: 0,
  guideMinutes: 0,
  maxChannels: 0,
  unionId: '',
  aiPptVideoDuration: 0,
  aiPptVideoWithDigitalHumanDuration: 0
};

export default {
  mixins: [dialogMixin, accountInfoMixin],
  data() {
    return {
      type: 'add',
      loading: false,
      form: { ...defaultForm },
      assignedForm: {},
      unitData: {
        concurrent: '并发',
        minutes: '分钟',
        flow: 'GB',
        linkMicMinutes: '分钟',
        guideMinutes: '分钟',
        maxChannels: '个',
        aiPptVideoDuration: '分钟',
        aiPptVideoWithDigitalHumanDuration: '分钟'
      },
      billingMethod: '',
      chargeTypeEnum
    };
  },
  computed: {
    ...mapState({
      accountInfo: state => state.account.accountInfo
    }),
    showConcurrent() {
      const billingMethod = this.type === 'add' ? this.billingMethod : this.form.chargeType;
      return billingMethod === 'concurrent';
    },
    showMinutes() {
      const billingMethod = this.type === 'add' ? this.billingMethod : this.form.chargeType;
      return billingMethod === chargeTypeEnum.Minutes;
    },
    showLiveFlow() {
      const billingMethod = this.type === 'add' ? this.billingMethod : this.form.chargeType;
      return billingMethod === chargeTypeEnum.LiveFlow;
    },
    billingMethodOptions() {
      const optionData = [];
      if (this.overViewInfo.liveBillingPlan === chargeTypeEnum.LiveFlow) {
        optionData.push({ label: '按流量计费', value: chargeTypeEnum.LiveFlow });
      } else {
        optionData.push({ label: '按分钟数计费', value: chargeTypeEnum.Minutes });
      }
      // 并行并发或者累计并发，才支持选“并发计费”
      const { totalConcurrent, ParallelConcurrent } = this.chargeTypeEnum;
      if (this.concurrentType === totalConcurrent || this.concurrentType === ParallelConcurrent) {
        optionData.push({ label: '按并发计费', value: 'concurrent' });
      }
      return optionData;
    },
    showAiPptVideoDuration() {
      return ynToBool(this.accountInfo.aiPPTVideoEnabled, 'N');
    },
    showAiPptVideoWithDigitalHumanDuration() {
      return ynToBool(this.accountInfo.aiPPTVideoDigitalHumanEnabled, 'N');
    },
  },
  methods: {
    open(type, data = {}) {
      this.type = type;
      this.form.chargeType = data.chargeType;
      this.form.unionId = data.unionId;
      this.assignedForm = { ...data };
      this.$emit('update:visible', true);
    },
    async handleSubmit() {
      if (this.loading) return;
      const isAdd = this.type === 'add';
      const form = this.buildBaseForm(isAdd);
      if (!this.validateAiPptDurations(isAdd) || !this.validateAiPptVideoWithDigitalHumanDuration(isAdd)) return;
      this.assignAiPptDurations(form, isAdd);

      this.loading = true;
      try {
        await this.$store.dispatch('account/allocateLiveResource', form);
      } finally {
        this.loading = false;
      }

      this.$emit('updateSuccess');
    },

    buildBaseForm(isAdd) {
      return {
        chargeType: this.billingMethod,
        minutes: isAdd ? this.form.minutes : -this.form.minutes,
        concurrent: isAdd ? this.form.concurrent : -this.form.concurrent,
        maxChannels: isAdd ? this.form.maxChannels : -this.form.maxChannels,
        linkMicMinutes: isAdd ? this.form.linkMicMinutes : -this.form.linkMicMinutes,
        guideMinutes: isAdd ? this.form.guideMinutes : -this.form.guideMinutes,
        liveFlow: isAdd ? this.form.liveFlow : -this.form.liveFlow,
        unionId: this.form.unionId
      };
    },

    validateAiPptDurations(isAdd) {
      if (!this.showAiPptVideoDuration || isAdd) return true;
      const duration = Number(this.form.aiPptVideoDuration);
      const isInvalidDuration = Number.isNaN(duration) || duration < 0 || !Number.isInteger(duration);
      if (!isInvalidDuration) return true;
      this.$toast.error('请输入正确的用量数值');
      return false;
    },
    validateAiPptVideoWithDigitalHumanDuration(isAdd) {
      if (!this.showAiPptVideoWithDigitalHumanDuration || isAdd) return true;
      const duration = Number(this.form.aiPptVideoWithDigitalHumanDuration);
      const isInvalidDuration = Number.isNaN(duration) || duration < 0 || !Number.isInteger(duration);
      if (!isInvalidDuration) return true;
      this.$toast.error('请输入正确的用量数值');
      return false;
    },

    assignAiPptDurations(form, isAdd) {
      if (this.showAiPptVideoDuration) {
        form.aiPptVideoDuration = isAdd ? this.form.aiPptVideoDuration : -this.form.aiPptVideoDuration;
      }
      if (this.showAiPptVideoWithDigitalHumanDuration) {
        form.aiPptVideoWithDigitalHumanDuration = isAdd ? this.form.aiPptVideoWithDigitalHumanDuration : -this.form.aiPptVideoWithDigitalHumanDuration;
      }
    },

    dataValidation(form) {
      // 检查form中如果为数字，是否小于0
      for (const key in form) {
        if (typeof form[key] === 'number' && form[key] < 0) { return false; }
      }
      return true;
    },

    handleDialogClose() {
      this.handleClose();
      this.form = { ...defaultForm };
    }
  }
};
</script>

<style>
.c-live-distribute__tip {
  margin-top: 14px;
}
.c-live-distribute__text {
  height: 40px;
  line-height: 40px;
}
</style>
